import { useState, useEffect } from "react";
import './Marketplace.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
import {useLocation } from "react-router-dom";
import MarketSlide from "../../Component/Marketplace/MarketSlide/MarketSlide";
import BetaWaitlist from "../../Component/Beta-Waitlist/BetaWaitlist";
import { Accordion } from "react-bootstrap";
//import { useNavigate } from "react-router-dom";
import MarketPlacePageSlide from "../../Component/MarketPlacePageSlide/MarketPlacePageSlide/MarketPlacePageSlide";


const Marketplace = ()=> {

    const [showWaitlist, setShowWaitlist] = useState(false);

    const [isMarketOpen, setMarketOpen] = useState(false);

   // const navigate = useNavigate();
    const location = useLocation();

       // Function to handle navigation
    //    const handleNavigation = (section) => {
    //     if (location.pathname !== "/") {
    //         navigate("/", { state: { scrollTo: section } });
    //     } else {
    //         scrollToSection(section);
    //     }
    // };

     // Function to scroll to section
     const scrollToSection = (section) => {
        setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 300);
    };

       
       useEffect(() => {
        if (location.state?.scrollTo) {
            scrollToSection(location.state.scrollTo);
        }
    }, [location]);


    return (
        <>
            <AIheader/>

            <BetaWaitlist
            showJoinWaitList={showWaitlist}
            onClose={() => setShowWaitlist(false)}
            onOpen={() => setShowWaitlist(true)}
           />

            {/* START marketPlaceBannerMain */}
            <section className='marketPlaceBannerMain'>
                <div className='marketPlaceBannerOuter'>
                    <div className='container-fluid'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='marketPlaceBannerInner'>
                                    <h1><img className='img-fluid' src="/img/Technology/rentid_logo_white.svg" alt="Marketplace"/> Marketplace</h1>
                                    <h2>Join the only commission-free<br/> car rental marketplace</h2>
                                    <p>Purpose-built & ethical car rental marketplace to give  businesses<br/>
                                     full control of their brand, guest experience, and revenue.</p>
                                    <a className="btn btnMarketPlace" href="/contact-sales">Contact Sales</a>
                                </div>

                                <div className='marketPlaceBannerList'>
                                    <ul>
                                        <li>
                                            <img src="/img/Pricing/check_green.svg" alt="check"/>
                                            Reach more renters
                                        </li>
                                        <li>
                                            <img src="/img/Pricing/check_green.svg" alt="check"/>
                                            Integrated Trust and Safety
                                        </li>
                                        <li>
                                            <img src="/img/Pricing/check_green.svg" alt="check"/>
                                            Embedded Insurance Plans
                                        </li>
                                        <li>
                                            <img src="/img/Pricing/check_green.svg" alt="check"/>
                                            Keep 100% of your earnings 
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END marketPlaceBannerMain */}
  

            {/* STRAT earnMoreMain */}
            <section className='earnMoreMain'>
                <div className="earnMoreOuter">
                    <div className='container'>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6">
                                <div className="earnMoreLeft">
                                    <h2>Earn more than any other marketplace.</h2>
                                    <p>You’re in the driver’s seat with full control pricing, 
                                    availability, and terms. Earn more on every booking, 
                                    unlike any other car sharing marketplaces.</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="earnMoreRight">
                                    <figure>
                                        <img className='img-fluid' src="/img/Marketplace/earnMore_1.png" alt="Marketplace"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END earnMoreMain */}


            {/* START listingYourMain */}
            <section className='listingYourMain'>
                <div className='container'>
                    <div className='listingYourOuter'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='listingYourInner'>
                                    <h2>Listing your vehicles <br/>on rentid is easy </h2>
                                    <figure>
                                        <img className='img-fluid' src="/img/Marketplace/rentAi.svg" alt="Listing your vehicles on rentid"/>
                                    </figure>
                                </div>
                                <div className='listingYourImage'>
                                    <img className='img-fluid' src="/img/Marketplace/listingYour.png" alt="Listing your vehicles on rentid"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END listingYourMain */}


            {/* STRAT useOurMain */}
            <section className='useOurMain'> 
                <div className='container'>
                    {/* row start */} 
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="useOurHeading">
                                <h2>Use our powerful AI, manual input or .csv to 
                                upload vehicles to the fleet manager.</h2>
                            </div>
                        </div>
                    </div>
                
                    <div className="row justify-content-center">
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                            <div className="useOurInner">
                                <figure>
                                    <img className="img-fluid" src="/img/Marketplace/ai_power.svg" alt="AI Powered Vehicle Onboarding"/>
                                </figure> 
                                <h3>AI Powered Vehicle<br/> Onboarding</h3>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                            <div className="useOurInner">
                                <figure>
                                    <img className="img-fluid" src="/img/Marketplace/stop_watch.svg" alt="Snooze Listings at Anytime"/>
                                </figure> 
                                <h3>Snooze Listings<br/> at Anytime</h3>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                            <div className="useOurInner">
                                <figure>
                                    <img className="img-fluid" src="/img/Marketplace/cloud_upload.svg" alt="Customer Success Fleet Import"/>
                                </figure> 
                                <h3>Customer Success<br/> Fleet Import</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END useOurMain */}
 
             {/* START delegateMain */}
             <section className="delegateMain">
                <div className="delegateOuter"> 
                    <div className="container">  
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="delegateHead">
                                    <h2>Delegate team members to manage your<br/> vehicles with all the tools included.</h2>
                                    <p>From staff to co-hosts or friends & family, assign <br/>
                                    anyone you'd like to manage your listings</p>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12'>
                                <div className='delegateAreaTop'>
                                    <div className='delegateArea delegateArea_1'>
                                        <div className='delegateInner'>
                                            <figure>
                                                <img className="img-fluid" src="/img/Marketplace/shirley.png" alt="Shirley"/>
                                            </figure>
                                            <h3>Shirley</h3>
                                            <p>Customer Service <br/>Rental Brand</p>
                                    
                                        </div>
                                        <div className='delegateImages'>
                                            <img className="img" src="/img/Marketplace/delegate_1.png" alt="rent id"/>
                                        </div>
                                    </div>

                                    <div className='delegateArea delegateArea_2'>
                                        <div className='delegateInner'>
                                            <figure>
                                                <img className="img-fluid" src="/img/Marketplace/john.png" alt="john"/>
                                            </figure>
                                            <h3>John</h3>
                                            <p>Branch Manager<br/> Rental Brand</p>
                                            <img className="delegate_21" src="/img/Marketplace/delegate_21.svg" alt="rent id"/>
                                            <img className="delegate_22" src="/img/Marketplace/delegate_22.svg" alt="rent id"/>
                                        </div>
                                        <div className='delegateImages'>
                                            <img className="img" src="/img/Marketplace/delegate_2.png" alt="rent id"/>
                                        </div>
                                    </div>

                                    <div className='delegateArea delegateArea_3'>
                                        <div className='delegateInner'>
                                            <figure>
                                                <img className="img-fluid" src="/img/Marketplace/mario.png" alt="mario"/>
                                            </figure>
                                            <h3>Mario</h3>
                                            <p>Co-Host <br/>Rental Brand</p>
                                        </div>
                                        <div className='delegateImages'>
                                            <img className="img" src="/img/Marketplace/delegate_3.png" alt="rent id"/>
                                        </div>
                                    </div>

                                    <div className='delegateArea delegateArea_4'>
                                        <div className='delegateInner'>
                                            <figure>
                                                <img className="img-fluid" src="/img/Marketplace/christy.png" alt="Christy"/>
                                            </figure>
                                            <h3>Christy</h3>
                                            <p>Marketing <br/>Rental Brand</p>
                                        </div>
                                        <div className='delegateImages'>
                                            <img className="img" src="/img/Marketplace/delegate_4.png" alt="rent id"/>
                                        </div>
                                    </div>
            
                                    <div className='delegateArea delegateArea_5'>
                                        <div className='delegateInner'>
                                            <figure>
                                                <img className="img-fluid" src="/img/Marketplace/marcelo.png" alt="Marcelo"/>
                                            </figure>
                                            <h3>Marcelo</h3>
                                            <p>Fleet Manager <br/>Rental Brand</p>
                                        </div>
                                        <div className='delegateImages'>
                                            <img className="img" src="/img/Marketplace/delegate_5.png" alt="rent id"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END delegateMain */}

 
            {/* START protectEveryMain */}
            <section className='protectEveryMain'>
                <div className='container'> 
                        <div className='row justify-content-center'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='protectEveryInner'>
                                    <figure>
                                        <img className='img-fluid' src="/img/Marketplace/rentShield.svg" alt="rent id"/>
                                    </figure>
                                    <h2>Protect every rental with<br/> embedded coverages.</h2>
                                    <p>Mandatory and most requested protection services available for each rental </p>

                                    <ul>
                                        <li>
                                            State Minimum Liability Insurance
                                            <img src="/img/Marketplace/tick_green.svg" alt="check"/>
                                        </li>
                                        <li>
                                            Physical Damage Coverage up to $110k
                                            <img src="/img/Marketplace/tick_green.svg" alt="check"/>
                                        </li>
                                        <li>
                                            Secondary Liability Insurance up to $1M
                                            <img src="/img/Marketplace/tick_green.svg" alt="check"/>
                                        </li>
                                        <li>
                                            Roadside Assistance Protection
                                            <img src="/img/Marketplace/tick_green.svg" alt="check"/>
                                        </li>
                                    </ul>
                                </div>
                    
                            </div>
                        </div>
                    </div>
            </section>
            {/* END protectEveryMain */}


            {/* STRAT myBusinessMain */}
            <section className='myBusinessMain'>
                <div className="myBusinessOuter">
                    <div className='container'>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6">
                                <div className="myBusinessLeft">
                                    <h2><span>Find My Business.</span> <br/>Easily Locate <br/>Vehicles & Hosts </h2>
                                    <p>Rentid’s marketplace let’s you search for both vehicles and hosts allowing guests to easily rebook their next trip with you.</p>
                                    <div className="myBusinesInner">
                                        <ul className="nav nav-tabs">
                                            <li className="nav-item">
                                                <a className="nav-link active" data-bs-toggle="tab" href="#host_View">
                                                    <img className='img-fluid' src="/img/Marketplace/touch_icon.svg" alt="Host View"/>
                                                    Host View
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" data-bs-toggle="tab" href="#vehicleView">
                                                    <img className='img-fluid' src="/img/Marketplace/touch_icon.svg" alt="Vehicle View"/>
                                                    Vehicle View
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="myBusinessRight">
                                    <div className="tab-content">
                                        {/* START Tab 1 */}
                                        <div className="tab-pane active" id="host_View">
                                            <figure>
                                                <img className='img-fluid' src="/img/Marketplace/host_View.png" alt="Host View"/>
                                            </figure>
                                        </div>
                                        {/* END Tab 1 */}

                                        {/* START Tab 2 */}
                                        <div className="tab-pane fade" id="vehicleView">
                                            <figure>
                                                <img className='img-fluid' src="/img/Marketplace/vehicleView.png" alt="Vehicle View"/>
                                            </figure>
                                        </div> 
                                        {/* END Tab 2 */}
                                    </div>
                           
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END myBusinessMain */}
            
            <MarketPlacePageSlide/>

            {/* START marketPlacePageSlideMain */}
            <section className="marketPlacePageSlideMain" style={{ display: 'none' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="marketPlacePageHead">
                                <h2>Helping Guest Come Back To Your Business</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="marketPlacePageSlider">
                    <div className="carousel-container">
                        <div className="carousel">
                            <div className="carousel-track">
                                {/* START 1 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Modernized<br/> Rental Experience</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/refresh_icon.svg" alt="Rental Experience"/>
                                        </figure>
                                        <p>Guests skip the outdated rental counters and clunky apps. Hosts like 
                                        you deliver a smooth, tech-forward experience from search to pickup.</p>
                                    </div>
                                </div>

         
                                {/* START 2 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Supporting<br/> Local Economy</h3>
                                    <div className="marketPlacePageDetailEase">
                                       <figure>
                                        <img className="img-fluid" src="/img/Marketplace/user_icon.svg" alt="Supporting Local Economy"/>
                                    </figure>
                                    <p>Every booking supports an independent host. No big chains or middlemen—just 
                                    real operators providing great service on their own terms.</p>
                                    </div>
                                </div>

                                {/* START 3 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>No Commissions. No<br/> Hidden Fees.</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                        <img className="img-fluid" src="/img/Marketplace/not_touch_icon.svg" alt="Commissions"/>
                                    </figure>
                                    <p>What guests see is what they pay. Rates are upfront, policies are clear, 
                                    and every dollar goes straight to the host they choose.</p>
                                    </div>
                                </div>
                     
 
                                {/* START 4 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Verified Drivers.<br/> Trusted Rentals.</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                        <img className="img-fluid" src="/img/Marketplace/id_icon.svg" alt="Verified Drivers"/>
                                    </figure>
                                    <p>RentID™ vetting and visible DriverIQ™ Scores help foster a safer community where 
                                    hosts and guests can trust who they’re working with.</p>
                                    </div>
                                </div> 

                                {/* START 5 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Flexible Protection,<br/> Peace of Mind</h3>
                                    <div className="marketPlacePageDetailEase">
                                    <figure>
                                        <img className="img-fluid" src="/img/Marketplace/security_icon.svg" alt="Flexible Protection"/>
                                    </figure>
                                    <p>Guests choose the protection plan that fits their trip, with optional roadside 
                                    assistance —because peace of mind shouldn’t cost extra.</p>
                                    </div>
                                </div>
                                
                                {/* START 6 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Find Your Favorites,<br/> Book Again</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/favourite_icon.svg" alt="Find Your Favorites Book Again"/>
                                        </figure>
                                        <p>Enjoyed your last car rental host experience? Guests can follow profiles, save vehicles, 
                                        and rebook their go-to rides with just a few taps.</p>
                                    </div>
                                </div>
                                                           
                                {/* START 7 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Rate and Reward<br/> Excellent Hosts</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/star_icon.svg" alt="Rate and Reward Excellent Hosts"/>
                                        </figure>
                                        <p>Reviews, tips, and positive feedback help guests recognize standout 
                                        hosts and shape a community built on excellent service.</p>
                                    </div>
                                </div>   

                                {/* START 8 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>One Profile. Limitless <br/> Possibilities.</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/rocket-_icon.svg" alt="One Profile. Limitless Possibilities"/>
                                        </figure>
                                        <p>Guests manage all their trips across cities, vehicles, and hosts in 
                                        one clean, modern account—rental freedom made easy.</p>
                                    </div>
                                </div>
                            </div>
                            {/* Duplicated */}
                            <div className="carousel-track">
                                {/* START 1 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Modernized<br/> Rental Experience</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/refresh_icon.svg" alt="Modernized Rental Experience"/>
                                        </figure>
                                        <p>Guests skip the outdated rental counters and clunky apps. Hosts like 
                                        you deliver a smooth, tech-forward experience from search to pickup.</p>
                                    </div>
                                </div>

         
                                {/* START 2 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Supporting<br/> Local Economy</h3>
                                    <div className="marketPlacePageDetailEase">
                                       <figure>
                                        <img className="img-fluid" src="/img/Marketplace/user_icon.svg" alt="Supporting Local Economy"/>
                                    </figure>
                                    <p>Every booking supports an independent host. No big chains or middlemen—just 
                                    real operators providing great service on their own terms.</p>
                                    </div>
                                </div>

                                {/* START 3 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>No Commissions. No<br/> Hidden Fees.</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                        <img className="img-fluid" src="/img/Marketplace/not_touch_icon.svg" alt="Commissions"/>
                                    </figure>
                                    <p>What guests see is what they pay. Rates are upfront, policies are clear, 
                                    and every dollar goes straight to the host they choose.</p>
                                    </div>
                                </div>
                     
 
                                {/* START 4 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Verified Drivers.<br/> Trusted Rentals.</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                        <img className="img-fluid" src="/img/Marketplace/id_icon.svg" alt="Verified Drivers"/>
                                    </figure>
                                    <p>RentID™ vetting and visible DriverIQ™ Scores help foster a safer community where 
                                    hosts and guests can trust who they’re working with.</p>
                                    </div>
                                </div> 

                                {/* START 5 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Flexible Protection,<br/> Peace of Mind</h3>
                                    <div className="marketPlacePageDetailEase">
                                    <figure>
                                        <img className="img-fluid" src="/img/Marketplace/security_icon.svg" alt="Flexible Protection Peace of Mind"/>
                                    </figure>
                                    <p>Guests choose the protection plan that fits their trip, with optional roadside 
                                    assistance —because peace of mind shouldn’t cost extra.</p>
                                    </div>
                                </div>
                                
                                {/* START 6 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Find Your Favorites,<br/> Book Again</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/favourite_icon.svg" alt="Find Your Favorites Book Again"/>
                                        </figure>
                                        <p>Enjoyed your last car rental host experience? Guests can follow profiles, save vehicles, 
                                        and rebook their go-to rides with just a few taps.</p>
                                    </div>
                                </div>
                                                           
                                {/* START 7 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>Rate and Reward<br/> Excellent Hosts</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/star_icon.svg" alt="Rate and Reward Excellent Hosts"/>
                                        </figure>
                                        <p>Reviews, tips, and positive feedback help guests recognize standout 
                                        hosts and shape a community built on excellent service.</p>
                                    </div>
                                </div>   

                                {/* START 8 */}
                                <div className="marketPlacePageDetail"> 
                                    <h3>One Profile. Limitless <br/> Possibilities.</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/rocket-_icon.svg" alt="One Profile Limitless Possibilities"/>
                                        </figure>
                                        <p>Guests manage all their trips across cities, vehicles, and hosts in 
                                        one clean, modern account—rental freedom made easy.</p>
                                    </div>
                                </div>
                            </div>
                            {/* Duplicated */}
                        </div>
                    </div>
                </div>
            </section>
            {/* END marketPlacePageSlideMain */}


            {/* START marketPlaceTabMain */}
            <section className="marketPlaceTabMain">
                <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="marketPlaceHead">
                                    <h2>Your Business. Your Revenue. <br/><span>Stand out with Rentid.</span></h2>
                                    <p>The new operating system for modern car rental businesses.</p>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="marketPlaceTabList">
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <a className="nav-link active" data-bs-toggle="tab" href="#marketPlaceTab_1">Branded Storefronts</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" data-bs-toggle="tab" href="#marketPlaceTab_2">Built-In Tools</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" data-bs-toggle="tab" href="#marketPlaceTab_3">Guest Experience</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" data-bs-toggle="tab" href="#marketPlaceTab_4">Designed for Scale</a>
                                        </li>
                                    </ul>
                
                                    <div className="tab-content">
                                        {/* START Tab 1 */}
                                        <div className="tab-pane active" id="marketPlaceTab_1">
                                            <MarketSlide/>
                                        </div>
                                        {/* END Tab 1 */}

                                        {/* START Tab 2 */}
                                        <div className="tab-pane fade" id="marketPlaceTab_2">
                                            <div className="marketPlaceTabOuter marketPlaceTabOuter_2">
                                                <div className="row justify-content-center align-items-center">
                                                    <div className="col-lg-6">
                                                        <div className="marketPlaceTabLeft">
                                                            <figure>
                                                                <img className="img-fluid" src="/img/Marketplace/marketPlaceTab_2.png" alt="Rental Ready Tools & Workflows"/>
                                                            </figure>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="marketPlaceTabRight">
                                                            <h3>Rental Ready<br/> Tools & Workflows</h3>
                                                            <p>Built-In tools for every step Rentid includes RentDirect™ for 
                                                            booking, RentID™ for AI-powered guest screening and ID verification, 
                                                            RentShield™ for insurance and roadside protection, and RentSuccess 
                                                            for support, resolutions, and recovery services. Operators manage 
                                                            bookings, availability, delivery, and pricing from one clean dashboard.</p>
                                                            <ul>
                                                                <li>Fleet Management</li>
                                                                <li>Daily Insurance</li>
                                                                <li>ID Verification</li>
                                                                <li>Insurance Validation</li>
                                                                <li>Fraud Detection</li>
                                                                <li>Branding</li>
                                                                <li>Marketing</li>
                                                                <li>Inbox Messaging</li>
                                                                <li>Cancellation Policy</li>
                                                                <li>Resolution Center</li>
                                                                <li>Customize Platform </li>
                                                                <li>Analytics</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                        {/* END Tab 2 */}

                                        {/* START Tab 3 */}
                                        <div className="tab-pane fade" id="marketPlaceTab_3">
                                            <div className="marketPlaceTabOuter marketPlaceTabOuter_3">
                                                <div className="row justify-content-center align-items-center">
                                                    <div className="col-lg-6">
                                                        <div className="marketPlaceTabRight">
                                                            <h3>Guest Experience, <br/>Reimagined</h3>
                                                            <p>Guests book confidently and come back directly to your business with 
                                                            clear trip terms and transparent costs. From mobile check-ins to direct 
                                                            messaging, every experience feels professional and personal.</p>
                                                            <ul>
                                                                <li>Branded Experience</li>
                                                                <li>Search</li>
                                                                <li>Promotions</li>
                                                                <li>Protection Plans</li>
                                                                <li>Extras</li>
                                                                <li>Secure Payments</li>
                                                                <li>ID Verification</li>
                                                                <li>Insurance Validation</li>
                                                                <li>Scheduled Instructions</li>
                                                                <li>Messaging</li>
                                                                <li>Start Trip</li>
                                                                <li>End Trip</li>
                                                                <li>Trip Photos</li>
                                                                <li>Rental Agreement</li>
                                                                <li>Insurance Card</li>
                                                                <li>Modify Trip</li>
                                                                <li>File Claim</li>
                                                                <li>Review System</li>
                                                                <li>Leave Tip</li>
                                                                <li>Remarketing</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="marketPlaceTabLeft">
                                                            <video width="380" height="572" controls loop autoPlay muted playsInline>
                                                                <source src="/img/Marketplace/marketPlaceTab_3.mp4" type="video/mp4" />
                                                            </video> 
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                        {/* END Tab 3 */}

                                        {/* START Tab 4 */}
                                        <div className="tab-pane fade" id="marketPlaceTab_4">
                                            <div className="marketPlaceTabOuter">
                                                <div className="row justify-content-center align-items-center">
                                                    <div className="col-lg-6">
                                                    <figure>
                                                            <img className="img-fluid" src="/img/Marketplace/business_scale.png" alt="business scale"/>
                                                        </figure>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="marketFleetRight">
                                                            <h3>Designed for Business Scale</h3>
                                                            <p>Whether you're managing 1 car or 100+, Rentid grows with your fleet. 
                                                            Multi-location support, automated workflows, and operator-focused 
                                                            insights let you run a professional rental business with less friction.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                        {/* END Tab 4 */}
                                    </div>
                                </div>

                                <div className="choiceMarketPlace">
                                    <Accordion defaultActiveKey="0">
                                        {/* start 1 */}
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>
                                                Branded Storefronts
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <MarketSlide/>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* start 2 */}
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>
                                                Built-In Tools
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="marketPlaceTabOuter marketPlaceTabOuter_2">
                                                    <div className="row justify-content-center align-items-center">
                                                        <div className="col-lg-6">
                                                            <div className="marketPlaceTabLeft">
                                                                <figure>
                                                                    <img className="img-fluid" src="/img/Marketplace/marketPlaceTab_2.png" alt="Rental Ready Tools & Workflows"/>
                                                                </figure>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="marketPlaceTabRight">
                                                                <h3>Rental Ready<br/> Tools & Workflows</h3>
                                                                <p>Built-In tools for every step Rentid includes RentDirect™ for 
                                                                booking, RentID™ for AI-powered guest screening and ID verification, 
                                                                RentShield™ for insurance and roadside protection, and RentSuccess 
                                                                for support, resolutions, and recovery services. Operators manage 
                                                                bookings, availability, delivery, and pricing from one clean dashboard.</p>
                                                                <ul>
                                                                    <li>Fleet Management</li>
                                                                    <li>Daily Insurance</li>
                                                                    <li>ID Verification</li>
                                                                    <li>Insurance Validation</li>
                                                                    <li>Fraud Detection</li>
                                                                    <li>Branding</li>
                                                                    <li>Marketing</li>
                                                                    <li>Inbox Messaging</li>
                                                                    <li>Cancellation Policy</li>
                                                                    <li>Resolution Center</li>
                                                                    <li>Customize Platform </li>
                                                                    <li>Analytics</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* start 3 */}
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>
                                                Guest Experience
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                    <div className="marketPlaceTabOuter marketPlaceTabOuter_3">
                                                        <div className="row justify-content-center align-items-center">
                                                            <div className="col-lg-6">
                                                                <div className="marketPlaceTabRight">
                                                                    <h3>Guest Experience, <br/>Reimagined</h3>
                                                                    <p>Guests book confidently and come back directly to your business with 
                                                                    clear trip terms and transparent costs. From mobile check-ins to direct 
                                                                    messaging, every experience feels professional and personal.</p>
                                                                    <ul>
                                                                        <li>Branded Experience</li>
                                                                        <li>Search</li>
                                                                        <li>Promotions</li>
                                                                        <li>Protection Plans</li>
                                                                        <li>Extras</li>
                                                                        <li>Secure Payments</li>
                                                                        <li>ID Verification</li>
                                                                        <li>Insurance Validation</li>
                                                                        <li>Scheduled Instructions</li>
                                                                        <li>Messaging</li>
                                                                        <li>Start Trip</li>
                                                                        <li>End Trip</li>
                                                                        <li>Trip Photos</li>
                                                                        <li>Rental Agreement</li>
                                                                        <li>Insurance Card</li>
                                                                        <li>Modify Trip</li>
                                                                        <li>File Claim</li>
                                                                        <li>Review System</li>
                                                                        <li>Leave Tip</li>
                                                                        <li>Remarketing</li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="marketPlaceTabLeft">
                                                                    <video width="380" height="572" controls loop autoPlay muted playsInline>
                                                                        <source src="/img/Marketplace/marketPlaceTab_3.mp4" type="video/mp4" />
                                                                    </video> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* start 4 */}
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header>
                                                Designed for Scale
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                    <div className="marketPlaceTabOuter">
                                                        <div className="row justify-content-center align-items-center">
                                                            <div className="col-lg-6">
                                                                <div className='marketFleetOuter'>
                                                                    <div className='marketFleetLeft'>
                                                                        <img className="pieMarket" src="/img/Fleet/pie.svg" alt="pie"/>
                                                                        <small>FLEET SIZE</small>
                                                                        <div className='fleetsMarketHeading'>
                                                                            <img width="30px" src="/img/Fleet/car_sky.svg" alt="car"/>
                                                                            <h2>1 - 5 vehicles</h2>
                                                                        </div>
                                                                        <p>Getting started</p>
                                                                        <h3>What I need to know</h3> 
                                                                    </div>

                                                                    <div className='marketFleetLeft'>
                                                                        <img className="pieMarket" src="/img/Fleet/pie_2.svg" alt="pie"/>
                                                                        <small>FLEET SIZE</small>
                                                                        <div className='fleetsMarketHeading'>
                                                                            <img width="30px" src="/img/Fleet/car_sky.svg" alt="car"/>
                                                                            <h2>6 - 25 vehicles</h2>
                                                                        </div>
                                                                        <p>Growing Fleets</p>
                                                                        <h3>What’s the next step</h3> 
                                                                    </div>

                                                                    <div className='marketFleetLeft'>
                                                                        <img className="pieMarket" src="/img/Fleet/pie_3.svg" alt="pie"/>
                                                                        <small>FLEET SIZE</small>
                                                                        <div className='fleetsMarketHeading'>
                                                                            <img width="30px" src="/img/Fleet/car_sky.svg" alt="car"/>
                                                                            <h2>26 - 50 vehicles</h2>
                                                                        </div>
                                                                        <p>Scaleable Solutions </p>
                                                                        <h3>Leveraging Automation</h3> 
                                                                    </div>

                                                                    <div className='marketFleetLeft'>
                                                                        <img className="pieMarket" src="/img/Fleet/pie_4.svg" alt="pie"/>
                                                                        <small>FLEET SIZE</small>
                                                                        <div className='fleetsMarketHeading'>
                                                                            <img width="30px" src="/img/Fleet/car_sky.svg" alt="car"/>
                                                                            <h2>100+ Vehicles</h2>
                                                                        </div>
                                                                        <p>Data-backed decions</p>
                                                                        <h3>Enterprise Level Support</h3> 
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="marketFleetRight">
                                                                    <h3>Designed for Business Scale</h3>
                                                                    <p>Whether you're managing 1 car or 100+, Rentid grows with your fleet. 
                                                                    Multi-location support, automated workflows, and operator-focused 
                                                                    insights let you run a professional rental business with less friction.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        {/* end 4 */}
                                    </Accordion>
                                </div>

                            </div>
                        </div>
               
                </div> 
            </section>
            {/* END marketPlaceTabMain */}

            {/* START compareMarketMain */}
            <section className="compareMarketMain">
                <div className="container">
                    <div className="row">
                        <div className="compareMarketInner">
                            <div className="btnCompareMerket">
                                <a className="btn" onClick={() => setMarketOpen(!isMarketOpen)} 
                                aria-expanded={isMarketOpen} aria-controls="compareExample">
                                    <img width="18px" src={isMarketOpen ? "/img/Pricing/minus_sign.svg" : "/img/Pricing/plus_sign.svg"} alt="icon"/>Compare Car-Sharing Marketplace
                                </a>
                            </div>
                            <div className={`collapse ${isMarketOpen ? "show" : ""}`} id="compareExample">
                                <div className="howRentStandsOuter">
                                    <div className="howRentStands">
                                        <h2>How Rentid Stands Out from<br/> Car Sharing Marketplaces</h2>
                                        <figure className="howRentStandsImage">
                                            <img src="/img/Solutions/car_rental_table.png" alt="How Rentid Stands Out from Car Sharing Marketplaces"/>
                                        </figure>


                                        <div className="howRentDropdown">
                                            <h4> Feature </h4>
                                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                                {/* START 1 */}
                                                <div className="accordion-item rounded-3 border-0 shadow mb-2">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                        Pricing Control
                                                        </button>
                                                    </h2>
                                                    <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                                        <div className="accordion-body">
                                                            <h5>Rentid:</h5>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-green.svg" alt="check"/> <span>Yes, Set Your Own Rates</span></div>
                                                            <p>Car Sharing Platforms:</p>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-gray.svg" alt="check"/> <span>No, Marketplace can upsell your rate</span></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* START 2 */}
                                                <div className="accordion-item rounded-3 border-0 shadow mb-2">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsetwo" aria-expanded="false" aria-controls="flush-collapsetwo">
                                                        Hosts Approval or Decline Bookings
                                                        </button>
                                                    </h2>
                                                    <div id="flush-collapsetwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                                        <div className="accordion-body">
                                                            <h5>Rentid:</h5>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-green.svg" alt="check"/> <span>Yes, Full Control</span></div>
                                                            <p>Car Sharing Platforms</p>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-gray.svg" alt="check"/> <span>No, Marketplace controlled</span></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* START 3 */}
                                                <div className="accordion-item rounded-3 border-0 mb-2 shadow">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                                        Host Branding Identity
                                                        </button>
                                                    </h2>
                                                    <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                                        <div className="accordion-body">
                                                            <h5>Rentid:</h5>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-green.svg" alt="check"/> <span>Yes, Host Branded</span></div>
                                                            <p>Car Sharing Platforms</p>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-gray.svg" alt="check"/> <span>No, Marketplace branding</span></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* START 4 */}
                                                <div className="accordion-item rounded-3 border-0 mb-2 shadow">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsefour" aria-expanded="false" aria-controls="flush-collapsefour">
                                                        Unlimited Monthly Rentals
                                                        </button>
                                                    </h2>
                                                    <div id="flush-collapsefour" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                                        <div className="accordion-body">
                                                            <h5>Rentid:</h5>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-green.svg" alt="check"/> <span>Yes, Up To Calendar Month</span></div>
                                                            <p>Car Sharing Platforms:</p>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-gray.svg" alt="check"/> <span>No, Billed per day</span></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* START 5 */}
                                                <div className="accordion-item rounded-3 border-0 mb-2 shadow">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsefive" aria-expanded="false" aria-controls="flush-collapsefive">
                                                            Fleet Management
                                                        </button>
                                                    </h2>
                                                <div id="flush-collapsefive" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                                    <div className="accordion-body">
                                                            <h5>Rentid:</h5>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-green.svg" alt="check"/> <span>Yes, Scalable Fleet Tools</span></div>
                                                            <p>Car Sharing Platforms:</p>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-gray.svg" alt="check"/> <span>No, Limited fleet tools</span></div>

                                                        </div>
                                                    </div>
                                                </div>


                                                {/* START 6 */}
                                                <div className="accordion-item rounded-3 border-0 mb-2 shadow">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsesix" aria-expanded="false" aria-controls="flush-collapsesix">
                                                        Ongoing Rental Risk Tracking
                                                        </button>
                                                    </h2>
                                                    <div id="flush-collapsesix" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                                        <div className="accordion-body">
                                                            <h5>Rentid:</h5>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-green.svg" alt="check"/> <span>Yes, DriverIQ Score</span></div>
                                                            <p>Car Sharing Platforms</p>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-gray.svg" alt="check"/> <span>No, Single background check</span></div>
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                                

                                                {/* START 7 */}
                                                <div className="accordion-item rounded-3 border-0 mb-2 shadow">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button border-bottom collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseseven" aria-expanded="false" aria-controls="flush-collapseseven">
                                                        Ethical Pricing Transparency
                                                        </button>
                                                    </h2>
                                                <div id="flush-collapseseven" className="accordion-collapse collapse"        data-bs-parent="#accordionFlushExample">
                                                    <div className="accordion-body">
                                                            <h5>Rentid:</h5>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-green.svg" alt="check"/> <span>Yes, Fully Controlled  by Host</span></div>
                                                            <p>Car Sharing Platforms</p>
                                                            <div className="rentid-new-check"> <img src="/img/checkmark-circle-gray.svg" alt="check"/> <span>No, Dynamic pricing + hidden fees</span></div>
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* END */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </section>
            {/* END compareMarketMain */}

            {/* START rentalMarketPlaceMain */}
            <section className="rentalMarketPlaceMain">
                <div className="rentalMarketPlaceOuter"> 
                    <div className="container">   
                            <div className='row justify-content-center'>
                                <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                    <div className='rentalMarketHead'>
                                        <img className="img-fluid" src="/img/Marketplace/rentSuccess_icon.svg" alt="Resolution Center"/>
                                        <h2>Resolution Center</h2>
                                        <p>Back-office support to recover funds faster, reduce admin tasks, and <br/>save vehicle downtime with tools to simplify guest rental disputes.</p>
                                        <ul>
                                            <li>Tolls Management</li>
                                            <li>Traffic Ticket Management</li>
                                            <li>Report Guest Behavior</li>
                                            <li>Insurance Claims Management</li>
                                            <li>Refund Process</li>
                                            <li>Rental Violations</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className='row justify-content-center'>
                                <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                    <div className='rentalMarketInner'>

                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/resolutionSuccess.png" alt="Resolution Center"/>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                    
                  
                    </div>
                </div>
            </section>
            {/* END rentalMarketPlaceMain */}


            {/* STRAT landing-platform */}
            <section className='popularTopicsAnounceMain landing-platform'>
                <div className='container'>
                    {/* row start */}
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="popularTopicsAnounceHeading">
                                <h2>The Platform That Keeps Rentals Running</h2>
                            </div>
                        </div>
                    </div>
                    {/* row end */}

                    {/* row start */}
                    <div className="row justify-content-center">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/direct.svg" alt="blog"/>
                                    <h4><span>rent</span>direct</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>Smart Booking Management</h3>
                                    <p>All-in-one booking system connected to a suite of rental workflows & tools unlike any other.</p>
                                    <a href="/rentdirect" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/shield.svg" alt="blog"/>
                                    <h4><span>rent</span>shield</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>Embedded Protection When Needed</h3>
                                    <p>Choose flexible insurance coverages and roadside assistance that turns on when the car goes out.</p>
                                    <a href="/rentshield" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/id.svg" alt="blog"/>
                                    <h4><span>rent</span>id</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>Verify Every Guest, Instantly</h3>
                                    <p>Screen renters in seconds with ID, license, insurance checks and renter scoring.  </p>
                                    <a href="/rent-id" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/ai.svg" alt="blog"/>
                                    <h4><span>rent</span>ai</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>AI Rental Task Agent</h3>
                                    <p>AI rental agent that completes tasks, solves problems, & gets things done for your business. </p>
                                    <a href="/rentai" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/success.svg" alt="blog"/>
                                    <h4><span>rent</span>success</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>Built-In Support & Resolution Center</h3>
                                    <p>Dedicated support, real-time rental resolutions, and a focus on lasting customer loyalty.</p>
                                    <a href="/rentsuccess" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/academy.svg" alt="blog"/>
                                    <h4><span>rent</span>academy</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>On Demand Industry Education </h3>
                                    <p>Where experts drop knowledge & growth strategies on podcasts, articles, and video series,</p>
                                    <a href="/rentacademy" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* row end */}

                </div>
            </section>
            {/* END landing-platform */}
            

            {/* STRAT altSolutionsMain */}
            <section className='altSolutionsMain'>
                <div className='altSolutionsOuter'>
                    <div className='container'>
                        {/* row start */}
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="altSolutionsHead">
                                    <h2>Alternative solutions for your business</h2>
                                </div>
                            </div>
                        </div>
                        {/* row end */}


                        {/* row start */}
                        <div className="row justify-content-center">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="altSolutionsInner altSolutionsInner_1">
                                    <a href="/platform">
                                        <div className="techHeading">
                                            <h3>Platform</h3>
                                        </div>
                                        <div className="altSolutionsData">
                                            <figure>
                                                <img className="img-fluid" src="/img/Technology/platform_icon.svg" alt="platform"/>
                                            </figure>
                                            <div className="altSolutionsDataRight">
                                                <p>From on-board to on-rent<br/> in less than 60 minutes,<br/> all in one place.</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="altSolutionsInner altSolutionsInner_3">
                                    <a href="/enterprise">
                                        <div className="techHeading">
                                            <h3>Enterprise</h3>
                                        </div>
                                        <div className="altSolutionsData">
                                            <figure>
                                                <img className="img-fluid" src="/img/Technology/api_icon.svg" alt="Enterprise"/>
                                            </figure>
                                            <div className="altSolutionsDataRight">
                                                <p>Build with our rental<br/> workflows designed <br/>to scale any business.</p>
                                            </div>
                                        </div>
                                    </a> 
                                </div>
                            </div>
                        </div>
                        {/* row end */}
                    </div>
                </div>
            </section>
            {/* END altSolutionsMain */}


            {/* START expMarketPlaceMain */}
            <section className='expMarketPlaceMain'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='expMarketPlaceInner'>
                                <h2>The only <span> commissionless</span><br/> car rental marketplace made<br/> 
                                for <span>operators & their guests.</span></h2>
                                
                                <div className='expMarketPlaceBtn'>
                                     <a className="btn btnWhiteSpl" onClick={()=> setShowWaitlist(true)}>Join Waitlist
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                    {/* <BetaWaitlist buttonclass="btn btnWhiteSpl" buttonText="Join Waitlist" /> */}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END expMarketPlaceMain */}



            <Footer/>
        </>
    )
}

export default Marketplace;